import {
  SET_PWD_SELECTED,
  DELETE_PWD_SELECTED,
  ADD_POC_SELECTION,
  FETCH_FILER_CASE_DATA,
  FETCH_FILER_CASE_DATA_SUCCESS,
  FETCH_FILER_CASE_DATA_FAILED,
} from "./actions";

const initialState = {
  data: null, // Case data for 9141
  pw_selected: null, // Case number for 9141
  poc_selection: null, // section C or D
  primary_worksite: null,
  error: false,
};

function convertWagePer(wage_per) {
  const obj = {
    Hourly: "HR",
    Weekly: "WK",
    Biweekly: "BW",
    Monthly: "MH",
    Yearly: "YR",
  };
  return obj[wage_per] ? obj[wage_per] : wage_per;
}
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_PWD_SELECTED:
      return {
        ...state,
        pw_selected: action.meta_case_number,
      };
    case DELETE_PWD_SELECTED:
      return {
        ...state,
        pw_selected: null,
        data: null,
        poc_selection: null,
        primary_worksite: null,
      };
    case ADD_POC_SELECTION:
      return {
        ...state,
        poc_selection: action.selection,
      };
    case FETCH_FILER_CASE_DATA:
      return {
        ...state,
        data: action.payload,
        error: false,
      };
    case FETCH_FILER_CASE_DATA_SUCCESS:
      let caseData = action.payload;
      const primary_worksite = {
        meta_case_id: caseData.caseNumber || "",
        dateSubmitted: caseData.dateSubmitted || "",
        determinationDate: caseData.caseMetadata.determinationDate || "",
        ec1_address1: caseData.empAddr1 || "",
        ec1_address2: caseData.empAddr2 || "",
        worksiteCity: caseData.primaryWorksiteCity || "",
        worksitePostalCode: caseData.primaryWorksitePostalCode || "",
        worksiteCountyTownship: caseData.primaryWorksiteCounty
          ? caseData.primaryWorksiteCounty
          : "",
        worksiteState: caseData.primaryWorksiteState || "",
        worksiteBlsArea: caseData.primaryWorksiteBlsArea
          ? caseData.primaryWorksiteBlsArea.toUpperCase()
          : "",
        pwdWageRate: caseData.pwdWageRate || "",
        pwdUnitOfPay: convertWagePer(caseData.pwdUnitOfPay) || "",
      };
      return {
        ...state,
        data: caseData,
        primary_worksite: primary_worksite,
      };
    case FETCH_FILER_CASE_DATA_FAILED:
      return {
        ...state,
        data: {},
        primary_worksite: {},
        error: true,
      };
    default:
      return state;
  }
}
